module.exports = __webpack_public_path__ + "media/notEnoughCoin2.71f1d558.mp3";